import AccessDeniedDialog from "./dialogs/AccessDenied.vue";
import ErrorDialog from "./dialogs/Error.vue";
import Sidebar from "./Sidebar.vue";
import TopHeader from "./TopHeader.vue";

export const Components = {
    'dialog-access-denied': AccessDeniedDialog,
    'dialog-error': ErrorDialog,
    'sidebar': Sidebar,
    'top-header': TopHeader,
};
